import React from "react";
import ChevronDownIcon from "../../../assets/svg/chevron-down-icon";

interface AccordionButtonProps {
  children: React.ReactNode;
  isExpanded: boolean;
  onClick: () => void;
  ariaControls: string;
  accordionButtonClassName?: string;
}

const AccordionButton: React.FC<AccordionButtonProps> = ({
  children,
  isExpanded,
  onClick,
  ariaControls,
  accordionButtonClassName = "",
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div className="w-full" role="heading" aria-level={3}>
      <button
        className={`w-full flex items-center justify-between focus:outline-none ${
          accordionButtonClassName || "px-[12px] py-[16px]"
        }`}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        aria-expanded={isExpanded}
        aria-controls={ariaControls}
        type="button"
      >
        {children}
        <ChevronDownIcon
          className={`w-[10px] h-[10px] transition-transform duration-300 text-verba-indigo dark:text-verba-indigo-dk ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>
    </div>
  );
};

export default AccordionButton;
